module.exports = __webpack_public_path__ + "img/img7.658ed2ab.png";